export const translations = {
  ko: {
    common: {
      back: '이전',
      save: '저장하기',
      confirm: '확인',
      cancel: '취소',
      next: '다음',
      loading: '로딩 중...',
      won: '원',
    },
    home: {
      greeting: '반가워요!',
      spending: '지출',
      budgetStatus: '예산 관리 현황',
      used: '사용액',
      total: '총 예산',
      remaining: '남은 금액',
      totalSpentLabel: '총 사용금액',
      noBudgetSet: '0원',
      myPets: '나의 반려동물',
      recentTransactions: '최근 지출 내역',
      viewAll: '전체',
      noTransactions: '지출 내역이 없습니다.',
      manage: '관리',
      onboardingDesc: '우리 아이를 등록하고 스마트한 지출 관리를 시작해볼까요?',
      registerPet: '첫 반려동물 등록하기',
    },
    settings: {
      title: '계정 설정',
      appSettings: '앱 설정',
      support: '고객지원',
      notifications: '알림 설정',
      recurringCare: '정기 케어 관리',
      language: '언어 설정',
      faq: '자주 묻는 질문',
      inquiry: '1:1 문의하기',
      version: '버전 정보',
      logout: '로그아웃',
      logoutConfirm: '로그아웃 하시겠습니까?',
    },
    language: {
      title: '언어 설정',
      select: '사용하실 언어를 선택해 주세요.',
      ko: '한국어',
      en: 'English',
    }
  },
  en: {
    common: {
      back: 'Back',
      save: 'Save',
      confirm: 'Confirm',
      cancel: 'Cancel',
      next: 'Next',
      loading: 'Loading...',
      won: 'KRW',
    },
    home: {
      greeting: 'Welcome!',
      spending: 'Spent',
      budgetStatus: 'Budget Status',
      used: 'Used',
      total: 'Total',
      remaining: 'Remaining',
      totalSpentLabel: 'Total Spent',
      noBudgetSet: 'KRW 0',
      myPets: 'My Pets',
      recentTransactions: 'Recent Transactions',
      viewAll: 'All',
      noTransactions: 'No transactions found.',
      manage: 'Manage',
      onboardingDesc: 'Register your pet and start smart spending management!',
      registerPet: 'Register First Pet',
    },
    settings: {
      title: 'Settings',
      appSettings: 'App Settings',
      support: 'Support',
      notifications: 'Notifications',
      recurringCare: 'Regular Care',
      language: 'Language',
      faq: 'FAQ',
      inquiry: '1:1 Inquiry',
      version: 'Version',
      logout: 'Logout',
      logoutConfirm: 'Are you sure you want to logout?',
    },
    language: {
      title: 'Language Settings',
      select: 'Please select your language.',
      ko: '한국어',
      en: 'English',
    }
  }
};

export type Language = 'ko' | 'en';
export type TranslationType = typeof translations.ko;
